import { ENGLISH, SPANISH } from "../../context/languaje/types";

export const mainDescription = {
  [SPANISH]: `Nos enorgullece ser parte de tu camino hacia el éxito en League of Legends y esperamos acompañarte en cada paso del camino. ¡Únete a nuestra comunidad de jugadores apasionados y déjanos ayudarte a alcanzar nuevas alturas en el juego!`,
  [ENGLISH]: `We are proud to be a part of your journey to success in League of Legends and look forward to joining you every step of the way - join our community of passionate players and let us help you reach new heights in the game!`,
};

export const recentWorksSubTitle = {
  [SPANISH]: "Experiencias de Usuarios",
  [ENGLISH]: "User Experiences",
};

export const experiencesList = [
  {
    name: "anonimo",
    img: null,
    description: {
      [SPANISH]: `El servicio de coaching de League of Legends ha sido una experiencia realmente transformadora para mí. Los entrenadores demostraron una habilidad excepcional para transmitir sus conocimientos y técnicas, lo que me permitió mejorar mi juego de manera significativa.`,
      [ENGLISH]: `The League of Legends coaching service has been a truly transformative experience for me. The coaches demonstrated an exceptional ability to pass on their knowledge and techniques, which allowed me to improve my game significantly.`,
    },
  },
  {
    name: "anonimo",
    img: null,
    description: {
      [SPANISH]: `No puedo estar más satisfecho con el servicio de enseñanza de coaching que recibí. Gracias a la dedicación y paciencia del equipo, pude escalar muchas ligas y entender mejor el loslito, algo que nunca hubiera logrado por mi cuenta.`,
      [ENGLISH]: `I could not be more satisfied with the coaching teaching service I received. Thanks to the dedication and patience of the team, I was able to climb many leagues and gain a better understanding of loslito, something I would never have achieved on my own.`,
    },
  },
  {
    name: "anonimo",
    img: null,
    description: {
      [SPANISH]: `Recomendaría este servicio de coaching a cualquier jugador de League of Legends que busque un crecimiento real en su habilidad y conocimientos de macro juego avanzados. Los entrenadores personalizados me brindaron valiosos consejos estratégicos y tácticos que elevaron mi nivel de juego de manera impresionante.`,
      [ENGLISH]: `I would recommend this coaching service to any League of Legends player looking for real growth in their skill and advanced macro game knowledge. The personalized coaches provided me with valuable strategic and tactical advice that elevated my level of play impressively.`,
    },
  },
  {
    name: "anonimo",
    img: null,
    description: {
      [SPANISH]: `La enseñanza de coaching que recibí fue de primera clase. Los instructores no solo tenían un amplio conocimiento del juego, sino que también eran amables y alentadores. Fue una experiencia realmente positiva que me permitió adquirir nuevas habilidades y mejorar mis debilidades.`,
      [ENGLISH]: `The coaching instruction I received was first class. The instructors were not only knowledgeable about the game, but also friendly and encouraging. It was a really positive experience that allowed me to acquire new skills and improve my weaknesses.`,
    },
  },
  {
    name: "anonimo",
    img: null,
    description: {
      [SPANISH]: `Este servicio de coaching ha superado mis expectativas en todos los sentidos. La dedicación del equipo hacia mi progreso en League of Legends fue evidente en cada sesión. Gracias a ellos, ahora tengo una comprensión mucho más profunda del juego y he alcanzado un nivel que nunca pensé que sería posible para mí.`,
      [ENGLISH]: `This coaching service has exceeded my expectations in every way. The team's dedication to my progress in League of Legends was evident in every session. Thanks to them, I now have a much deeper understanding of the game and have reached a level I never thought possible for me.`,
    },
  },
  {
    name: "anonimo",
    img: null,
    description: {
      [SPANISH]: `Estaba estancado pero con muy buenas mecánicas, gracias a ellos pude digievolucionar xD y lograr subir de Diamante a maestro con los conceptos que me enseñaron y me esforcé por mejorar según sus tareas asignadas  y ser un mejor jugador tanto en la grieta como mentalmente hablando esto hace que crezcamos como jugadore`,
      [ENGLISH]: `I was stagnant but with very good mechanics, thanks to them I was able to digievolve xD and managed to climb from Diamond to master with the concepts they taught me and I strived to improve according to their assigned tasks and be a better player both in the rift and mentally speaking this makes us grow as players.`,
    },
  },
];
